import Bankstatementanalyzer from "../../../jsx/components/Dashboard/BankStatementAnalyzer/bankstatementanalyzer";

const BankStatementAnalyzerWrapper = () => {
  return <Bankstatementanalyzer />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.admin, _enum.ROUTE_PERSONAS.underwriter];
export default constore(BankStatementAnalyzerWrapper);
